// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_2uWGF","subTitle":"bt6VD"};